// Event Images API client. Gracefully degrades when backend is not configured.

const BASE_URL =
  process.env.REACT_APP_EVENT_IMAGES_API_URL ||
  "https://7vnhfarqxg.execute-api.us-east-1.amazonaws.com/prod";

let warnedNotConfigured = false;
const warnNotConfiguredOnce = () => {
  if (!warnedNotConfigured) {
    // eslint-disable-next-line no-console
    console.info(
      "Event Images API not configured; falling back to legacy options only."
    );
    warnedNotConfigured = true;
  }
};

const getToken = () => sessionStorage.getItem("cognitoIdToken");

const buildHeaders = (token) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});

export const fetchEventImages = async ({ activity } = {}) => {
  const token = getToken();
  if (!BASE_URL || !token) {
    warnNotConfiguredOnce();
    return { items: [] };
  }

  const url = new URL(`${BASE_URL.replace(/\/$/, "")}/event-images`);
  if (activity) {
    url.searchParams.set("activity", activity);
  }

  const response = await fetch(url.toString(), {
    method: "GET",
    headers: buildHeaders(token),
  });

  if (!response.ok) {
    throw new Error(
      `Failed to fetch event images: ${response.status} ${response.statusText}`
    );
  }

  const data = await response.json();
  return {
    items: Array.isArray(data?.items) ? data.items : [],
  };
};

export const fetchEventImageActivities = async () => {
  const token = getToken();
  if (!BASE_URL || !token) {
    warnNotConfiguredOnce();
    return { activities: [] };
  }

  const url = `${BASE_URL.replace(/\/$/, "")}/event-images/activities`;
  const response = await fetch(url, {
    method: "GET",
    headers: buildHeaders(token),
  });

  if (!response.ok) {
    throw new Error(
      `Failed to fetch event image activities: ${response.status} ${response.statusText}`
    );
  }

  const data = await response.json();
  return {
    activities: Array.isArray(data?.activities) ? data.activities : [],
  };
};
